import React, { useEffect, useState } from "react";
import { db } from "../firebase";

import {
  collection,
  query,
  orderBy,
  startAt,
  endAt,
  limit,
  getDocs,
  where,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

import "./AdminUserSearch.css";

const balanceFields = [
  "tshBalance",
  "usdtBalance",
  "USDBalance",
  "KESBalance",
  "UGXBalance",
  "RWFBalance",
  "BIFBalance",
  "ZMWBalance",
  "MWKBalance",
  "MZNBalance",
  "SSPBalance",
  "BWPBalance",
  "MGABalance",
  "usdtBalanceOther",
];

const textFields = [
  "username",
  "fullName",
  "email",
  "phoneNumber",
  "country",
  "password",
  "language",
  "role",
  "referralBy",
  "referralCode",
  "referralLink",
  "whoReferredWho",
  "bitcoinAddress",
  "trc20Address",
  "trxAddress",
  "bep20Address",
  "erc20Address",
  "solanaAddress",
];






const numberFields = [
  "walletIndex",
  "index",
  "depositedAmountOnJoinDay",
];


const statusFields = [
  "KO",
  "CHO",
  "BO",
  "MO",
  "SO",
  "TO",
  "OKX",
];


export default function AdminUserManager() {
  const [searchField, setSearchField] =
    useState("username");

  const [searchValue, setSearchValue] =
    useState("");

  const [users, setUsers] = useState([]);

  const [message, setMessage] =
    useState("");

  const [editingUser, setEditingUser] =
    useState(null);

  const [editedData, setEditedData] =
    useState({});

  const [loading, setLoading] =
    useState(false);




  useEffect(() => {
    const searchUsers = async () => {
      const value =
        searchValue.trim();

      setMessage("");
      setEditingUser(null);

      if (!value) {
        setUsers([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        const usersRef = collection(
          db,
          "users"
        );

        const q = query(
          usersRef,
          orderBy(searchField),
          startAt(value),
          endAt(value + "\uf8ff"),
          limit(30)
        );

        const snap =
          await getDocs(q);

        const result = snap.docs.map(
          (d) => ({
            id: d.id,
            ...d.data(),
          })
        );

        setUsers(result);

        setMessage(
          result.length === 0
            ? "No users found"
            : ""
        );
      } catch (err) {
        console.error(err);

        setMessage(
          "Search failed. Check Firestore indexes."
        );
      } finally {
        setLoading(false);
      }
    };

    searchUsers();
  }, [searchValue, searchField]);

  // EXACT SEARCH
  const handleExactSearch =
    async () => {
      const value =
        searchValue.trim();

      setMessage("");
      setEditingUser(null);

      if (!value) {
        setUsers([]);

        setMessage(
          "Please enter search value"
        );

        return;
      }

      try {
        setLoading(true);

        const usersRef = collection(
          db,
          "users"
        );

        const q = query(
          usersRef,
          where(searchField, "==", value)
        );

        const snap =
          await getDocs(q);

        const result = snap.docs.map(
          (d) => ({
            id: d.id,
            ...d.data(),
          })
        );

        setUsers(result);

        setMessage(
          result.length === 0
            ? "No users found"
            : ""
        );
      } catch (err) {
        console.error(err);

        setMessage("Search failed");
      } finally {
        setLoading(false);
      }
    };

  const formatDate = (value) => {
    if (!value) return "-";

    if (
      typeof value?.toDate ===
      "function"
    ) {
      return value
        .toDate()
        .toLocaleString();
    }

    return String(value);
  };
const handleEdit = (user) => {
  setEditingUser(user);

  setEditedData({
    ...user,
    status: user.status || "Active",

    KO: user.KO || "NO",
    CHO: user.CHO || "NO",
    BO: user.BO || "NO",
    MO: user.MO || "NO",
    SO: user.SO || "NO",
    TO: user.TO || "NO",
    OKX: user.OKX || "NO",
  });
};
  


  const handleCancel = () => {
    setEditingUser(null);

    setEditedData({});
  };

  const handleChange = (
    field,
    value
  ) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleUpdate = async () => {
    if (!editingUser?.id) return;

    try {
      const ref = doc(
        db,
        "users",
        editingUser.id
      );

      const safeData = {
        ...editedData,
      };

      balanceFields.forEach(
        (field) => {
          safeData[field] = Number(
            editedData[field] || 0
          );
        }
      );

      numberFields.forEach(
        (field) => {
          safeData[field] = Number(
            editedData[field] || 0
          );
        }
      );

      delete safeData.id;

      await updateDoc(
        ref,
        safeData
      );

      setUsers((prev) =>
        prev.map((u) =>
          u.id === editingUser.id
            ? {
                ...u,
                ...safeData,
              }
            : u
        )
      );

      setMessage(
        "Updated successfully"
      );

      setEditingUser(null);

      setEditedData({});
    } catch (err) {
      console.error(err);

      setMessage(
        "Update failed"
      );
    }
  };

  const handleDelete = async (
    id
  ) => {
    const ok = window.confirm(
      "Una uhakika unataka kufuta user huyu?"
    );

    if (!ok) return;

    try {
      await deleteDoc(
        doc(db, "users", id)
      );

      setUsers((prev) =>
        prev.filter(
          (u) => u.id !== id
        )
      );

      setMessage("User deleted");
    } catch (err) {
      console.error(err);

      setMessage("Delete failed");
    }
  };

  const FieldRow = ({
    label,
    value,
  }) => (
    <div className="detail-row">
      <span>{label}</span>

      <strong>
        {value || value === 0
          ? String(value)
          : "-"}
      </strong>
    </div>
  );

  const Input = ({
    label,
    field,
    type = "text",
  }) => (
    <div className="input-box">
      <label>{label}</label>

      <input
        type={type}
        value={
          editedData[field] ?? ""
        }
        onChange={(e) =>
          handleChange(
            field,
            e.target.value
          )
        }
      />
    </div>
  );

  return (
    <div className="admin-user-manager">
      <h2>
        Admin User Manager
      </h2>

      <div className="search-box">
        <select
          value={searchField}
          onChange={(e) => {
            setSearchField(
              e.target.value
            );

            setSearchValue("");

            setUsers([]);
          }}
        >
          <option value="username">
            Username
          </option>

          <option value="fullName">
            Full Name
          </option>

          <option value="phoneNumber">
            Phone
          </option>

          <option value="email">
            Email
          </option>

          <option value="referralCode">
            Referral Code
          </option>

          <option value="referralBy">
            Referral By
          </option>
        </select>

        <input
          value={searchValue}
          onChange={(e) =>
            setSearchValue(
              e.target.value
            )
          }
          placeholder="Anza kuandika mfano john12..."
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleExactSearch();
            }
          }}
        />

        <button
          type="button"
          onClick={
            handleExactSearch
          }
        >
          {loading
            ? "Searching..."
            : "Search"}
        </button>
      </div>

      {message && (
        <p className="admin-message">
          {message}
        </p>
      )}

      {users.map((user) => (
        <div
          key={user.id}
          className="user-card"
        >
          <div className="user-card-header">
            <div>
              <h3>
                {user.username}
              </h3>

              <p>
                {user.fullName}
              </p>
            </div>

            <span
              className={
                user.status ===
                "Blocked"
                  ? "badge blocked"
                  : user.status ===
                    "OK"
                  ? "badge ok"
                  : "badge active"
              }
            >
              {user.status ||
                "Active"}
            </span>
          </div>

          {editingUser?.id ===
          user.id ? (
            <div className="edit-area">
              <h4>
                Basic Information
              </h4>

              {textFields.map(
                (field) => (
                  <Input
                    key={field}
                    label={field}
                    field={field}
                  />
                )
              )}

              <h4>Numbers</h4>

              {numberFields.map(
                (field) => (
                  <Input
                    key={field}
                    label={field}
                    field={field}
                    type="number"
                  />
                )
              )}

              <h4>Balances</h4>

              <div className="balance-grid">
                {balanceFields.map(
                  (field) => (
                    <Input
                      key={field}
                      label={field}
                      field={field}
                      type="number"
                    />
                  )
                )}
              </div>
<h4>Platform Status</h4>





<div className="balance-grid">
  {statusFields.map((field) => (
    <div
      key={field}
      className="input-box"
    >
      <label>{field}</label>

      <select
        value={
          editedData[field] || "NO"
        }
        onChange={(e) =>
          handleChange(
            field,
            e.target.value
          )
        }
      >
        <option value="NO">
          NO
        </option>

        <option value="YES">
          YES
        </option>
      </select>
    </div>
  ))}
</div>
              <h4>Status</h4>

              <div className="input-box">
                <label>
                  Status
                </label>

                <select
                  value={
                    editedData.status ||
                    "Active"
                  }
                  onChange={(e) =>
                    handleChange(
                      "status",
                      e.target
                        .value
                    )
                  }
                >
                  <option value="Active">
                    Active
                  </option>

                  <option value="Blocked">
                    Blocked
                  </option>

                  <option value="OK">
                    OK
                  </option>
                </select>
              </div>

              <div className="action-row">
                <button
                  type="button"
                  className="save-btn"
                  onClick={
                    handleUpdate
                  }
                >
                  Save
                </button>

                <button
                  type="button"
                  className="cancel-btn"
                  onClick={
                    handleCancel
                  }
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="section">
                <h4>
                  Basic Information
                </h4>

                <FieldRow
                  label="Full Name"
                  value={
                    user.fullName
                  }
                />

                <FieldRow
                  label="Email"
                  value={
                    user.email
                  }
                />

                <FieldRow
                  label="Phone"
                  value={
                    user.phoneNumber
                  }
                />

                <FieldRow
                  label="Country"
                  value={
                    user.country
                  }
                />

                <FieldRow
                  label="Language"
                  value={
                    user.language
                  }
                />

                <FieldRow
                  label="Role"
                  value={user.role}
                />

                <FieldRow
                  label="Password"
                  value={
                    user.password
                  }
                />

                <FieldRow
                  label="Status"
                  value={
                    user.status ||
                    "Active"
                  }
                />

                <FieldRow
                  label="Created At"
                  value={formatDate(
                    user.createdAt
                  )}
                />

                <FieldRow
                  label="Block Expires At"
                  value={formatDate(
                    user.blockExpiresAt
                  )}
                />
              </div>

              <div className="section">
                <h4>
                  Referral Information
                </h4>

                <FieldRow
                  label="Referral Code"
                  value={
                    user.referralCode
                  }
                />

                <FieldRow
                  label="Referral By"
                  value={
                    user.referralBy
                  }
                />

                <FieldRow
                  label="Referral Link"
                  value={
                    user.referralLink
                  }
                />

                <FieldRow
                  label="Who Referred Who"
                  value={
                    user.whoReferredWho
                  }
                />
              </div>

              <div className="section">
                <h4>
                  Wallet Index
                </h4>

                <FieldRow
                  label="walletIndex"
                  value={
                    user.walletIndex
                  }
                />

                <FieldRow
                  label="index"
                  value={user.index}
                />

                <FieldRow
                  label="Deposited On Join Day"
                  value={
                    user.depositedAmountOnJoinDay
                  }
                />
              </div>

              <div className="section">
                <h4>Balances</h4>

                <div className="balance-view-grid">
                  {balanceFields.map(
                    (field) => (
                      <div
                        key={field}
                        className="balance-item"
                      >
                        <span>
                          {field}
                        </span>

                        <strong>
                          {Number(
                            user[
                              field
                            ] || 0
                          ).toLocaleString()}
                        </strong>
                      </div>
                    )
                  )}
                </div>
              </div>
<div className="section">
  <h4>Platform Status</h4>

  <div className="balance-view-grid">
    {statusFields.map((field) => (
      <div
        key={field}
        className="balance-item"
      >
        <span>{field}</span>

        <strong
          style={{
            color:
              user[field] === "YES"
                ? "green"
                : "red",
          }}
        >
          {user[field] || "NO"}
        </strong>
      </div>
    ))}
  </div>
</div>
     <div className="section">
                <h4>
                  Crypto Addresses
                </h4>

                <FieldRow
                  label="Bitcoin"
                  value={
                    user.bitcoinAddress
                  }
                />

                <FieldRow
                  label="TRC20"
                  value={
                    user.trc20Address
                  }
                />

                <FieldRow
                  label="TRX"
                  value={
                    user.trxAddress
                  }
                />

                <FieldRow
                  label="BEP20"
                  value={
                    user.bep20Address
                  }
                />

                <FieldRow
                  label="ERC20"
                  value={
                    user.erc20Address
                  }
                />

                <FieldRow
                  label="Solana"
                  value={
                    user.solanaAddress
                  }
                />
              </div>

              <div className="section">
                <h4>
                  Crypto Wallets Map
                </h4>

                {user.cryptoWallets ? (
                  Object.entries(
                    user.cryptoWallets
                  ).map(
                    ([
                      key,
                      wallet,
                    ]) => (
                      <div
                        key={key}
                        className="wallet-box"
                      >
                        <h5>
                          {key}
                        </h5>

                        <FieldRow
                          label="Coin"
                          value={
                            wallet?.coin
                          }
                        />

                        <FieldRow
                          label="Network"
                          value={
                            wallet?.network
                          }
                        />

                        <FieldRow
                          label="Address"
                          value={
                            wallet?.address
                          }
                        />
                      </div>
                    )
                  )
                ) : (
                  <p className="empty-text">
                    No crypto wallets
                  </p>
                )}
              </div>

              <div className="action-row">
                <button
                  type="button"
                  className="edit-btn"
                  onClick={() =>
                    handleEdit(
                      user
                    )
                  }
                >
                  Edit
                </button>

                <button
                  type="button"
                  className="delete-btn"
                  onClick={() =>
                    handleDelete(
                      user.id
                    )
                  }
                >
                  Delete
                </button>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
